import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateNotExpiredPipe } from '@thehubz/client/core';
import { AssetFiltersService } from '../../../services/asset-filters.service';
import { CollectionAssetViewRoutingModule } from './collection-asset-view-routing.module';

@NgModule({
  imports: [CommonModule, CollectionAssetViewRoutingModule],
  providers: [DatePipe, DateNotExpiredPipe, AssetFiltersService],
})
export class CollectionAssetViewModule {}
